import { toast } from "react-toastify";
import { POSTAPI } from "../config/Api";
import { ApiConstants } from "../constants/ApiConstants";
import { normalizeQuotationPdfUrl } from "./downloadQuotationPdf";

function openPdfUrlInNewTab(pdfUrl: string): boolean {
  const tab = window.open("", "_blank");
  if (!tab) {
    toast.error("Please allow pop-ups to view the PDF.");
    return false;
  }
  try {
    tab.opener = null;
  } catch {
    /* ignore */
  }
  tab.location.href = normalizeQuotationPdfUrl(pdfUrl);
  return true;
}

/** Fetch quote PDF from API and open it in a new browser tab (current tab unchanged). */
export async function openQuotationPdfInNewTab(quotationId: string): Promise<void> {
  const tab = window.open("", "_blank");
  if (!tab) {
    toast.error("Please allow pop-ups to view the PDF.");
    return;
  }
  try {
    tab.opener = null;
  } catch {
    /* ignore */
  }

  try {
    const res = await POSTAPI(
      ApiConstants.QuotesPdf,
      { quotation_id: quotationId },
      false,
    );
    const pdfUrl = res?.data?.PDF_URL;
    if (!res?.status || !pdfUrl) {
      tab.close();
      toast.error("Could not load PDF.");
      return;
    }
    tab.location.href = normalizeQuotationPdfUrl(pdfUrl);
  } catch {
    tab.close();
    toast.error("Could not load PDF.");
  }
}

/** Fetch order PDF from API and open it in a new browser tab (current tab unchanged). */
export async function openOrderPdfInNewTab(orderId: string): Promise<void> {
  const tab = window.open("", "_blank");
  if (!tab) {
    toast.error("Please allow pop-ups to view the PDF.");
    return;
  }
  try {
    tab.opener = null;
  } catch {
    /* ignore */
  }

  try {
    const res = await POSTAPI(
      ApiConstants.QuotesPdf,
      { type: "order", order_id: orderId },
      false,
    );
    const pdfUrl = res?.data?.PDF_URL;
    if (!res?.status || !pdfUrl) {
      tab.close();
      toast.error("Could not load PDF.");
      return;
    }
    tab.location.href = normalizeQuotationPdfUrl(pdfUrl);
  } catch {
    tab.close();
    toast.error("Could not load PDF.");
  }
}

/** Open an already-known PDF URL in a new tab (e.g. PDF preview route). */
export function openPdfUrlInNewBrowserTab(rawUrl: string): boolean {
  const url = normalizeQuotationPdfUrl(rawUrl);
  if (!url) {
    toast.error("Could not load PDF.");
    return false;
  }
  return openPdfUrlInNewTab(url);
}
